import { Chip } from '@mui/material';

export const RetentionTableHeader = [
  { field: 'admn_no', headerName: 'Admission No', width: 140 },
  { field: 'studentName', headerName: 'Student Name', width: 200 },

  { field: 'fromCourse', headerName: 'From Course', width: 180, toolTipGetter: true },
  { field: 'toCourse', headerName: 'To Course', width: 180, toolTipGetter: true },

  { field: 'retentionDate', headerName: 'Retention Date', width: 180 },

  { field: 'gapDays', headerName: 'Gap Days', width: 120 },

  {
    field: 'type',
    headerName: 'Type',
    width: 140,
  },

  {
    field: 'revenue',
    headerName: 'Revenue',
    width: 140,
  },

  {
    field: 'isCurrentlyPursuing',
    headerName: 'Active',
    width: 120,
    renderCell: ({ value }) => (
      <Chip label={value ? 'Active' : 'Inactive'} color={value ? 'success' : 'error'} size="small" />
    ),
  },
];
